<app-type-voie  *ngIf="isFr()"
	[uid]="'voie'+getUid()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[voie]="adr?.voie">
</app-type-voie>

<app-type-voie  *ngIf="!isFr()"
	[uid]="'voiee'+getUid()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[voie]="adr?.voie_e">
</app-type-voie>



<app-form-input
	*ngIf="isFr()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.cp"
	[label]="step1.getcp"
	[type]="'text'"
	[rule]="'required|pattern_3'"
	[errorMessage]="{'required' : 'ctr_105', 'pattern' : 'ctr_220'}"
	[name]="getUid()+'_SepAtt_cp'">
</app-form-input>
<app-form-input-error *ngIf="isFr()" [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>

<app-form-input *ngIf="!isFr()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.cp_e"
	[label]="step1.getcp_e"
	[type]="'text'"
	[rule]="'required|pattern_31|minSize_1|maxSize_10'"
	[errorMessage]="{'required' : 'ctr_105', 'pattern' : 'ctr_220'}"
	[name]="getUid()+'_SepAtt_cp_e'">
</app-form-input>

<app-form-input
	*ngIf="isFr()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.ville"
	[label]="step1.getville"
	[type]="'text'"
	[rule]="'required|pattern_21|maxSize_100'"
	[errorMessage]="{'required' : 'ctr_92', 'pattern' : 'ctr_40_HorsDef'}"
	[name]="getUid()+'_SepAtt_ville'">
</app-form-input>

<app-form-input
	*ngIf="!isFr()"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.ville_e"
	[label]="step1.getville"
	[type]="'text'"
	[rule]="'required|pattern_21|maxSize_100'"
	[errorMessage]="{'required' : 'ctr_92', 'pattern' : 'ctr_40_HorsDef'}"
	[name]="getUid()+'_SepAtt_ville_e'">
</app-form-input>

<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.pays"
	[label]="step1.getpays"
	[type]="'select'"
[typeSelect]="optionsSelectType"
	[optionsWithCode]="optionsSelect"
	[rule]="'pattern_25'"
	[errorMessage]="{'pattern' : 'ctr_48'}"
	[name]="getUid()+'_SepAtt_pays'">
</app-form-input>

<app-form-input *ngIf="false"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.bp"
	[label]="'bp'"
	[type]="'number'"
	[rule]="''"
	[name]="getUid()+'_SepAtt_bp'">
</app-form-input>

<app-form-input *ngIf="false"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.lieuDit"
	[label]="'lieuDit'"
	[type]="'text'"
	[rule]="''"
	[name]="getUid()+'_SepAtt_lieuDit'">
</app-form-input>

<app-form-input *ngIf="false"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[value]="adr?.cx"
	[label]="'cx'"
	[type]="'number'"
	[rule]="''"
	[name]="getUid()+'_SepAtt_cx'">
</app-form-input>
